import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";

const MySwal = withReactContent(Swal2);

const AddPou = (props) => {
  const [loading, setLoading] = useState(true);
  const [deliveryDate, setDeliveryDate] = useState(
    props.clientsData.pou ? props.clientsData.pou : ""
  );
  const [holidays, setHolidays] = useState([]);
  const [freeDays, setFreeDays] = useState([]);

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = async () => {
    fetchHolidays();
  };

  useEffect(() => {
    getData();
  }, []);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validate = () => {
    if (deliveryDate.length === 0) {
      return false;
    }

    return true;
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (new Date(el.date_from) >= final_date &&
            new Date(el.date_from) <= final_date) ||
          (final_date >= new Date(el.date_from) &&
            final_date <= new Date(el.date_to))
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const generateDocument = async () => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }

    var bodyX = {
      id: props.clientsData.id,
      date: deliveryDate,
    };

    fetch("https://apidevkppp.ftpeople.pl/updatePou", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(bodyX),
    })
      .then((response) => response.text())
      .then((responseJson) => {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "informacje o sprawie",
        }).then(async (result) => {
          props.close();
        });
      });
  };

  const handleDeliveryChange = (e) => {
    setDeliveryDate(e.target.value);
  };

  return (
    <div
      style={{ width: "50vw", top: "25vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <>
              <div id="addPaymentIC" className="inputContainer">
                <div className="inputBox">
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Pozew o ustalenie
                      <span className="requiredStar">*</span>
                    </label>
                    <select
                      style={{ boxSizing: "border-box" }}
                      type="text"
                      id="name"
                      name="name"
                      value={deliveryDate}
                      onChange={handleDeliveryChange}
                    >
                      {!deliveryDate ? (
                        <>
                          <option key={0} value={0}>
                            Wybierz...
                          </option>
                        </>
                      ) : (
                        ""
                      )}
                      <>
                        <option key={0} value="TAK">
                          TAK
                        </option>
                        <option key={0} value="NIE">
                          NIE
                        </option>
                      </>
                    </select>
                  </div>
                </div>
              </div>
            </>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={generateDocument}>
                ZAPISZ
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddPou;
